export default "__VITE_ASSET__CEkMKUFN__"